module.exports = __webpack_public_path__ + "img/3.85a9ece3.jpg";